import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IAffiliateTrackerConditionsResponse } from '../types';
import { AFFILIATE_TRACKER_CONDITIONS_API_URL, AFFILIATE_TRACKER_CONDITIONS_QUERY, AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS } from '../constants';

export default function useAffiliateTrackerConditionsQuery(id: Ref<number>, enabled: Ref<boolean>): IContextQueryResult<
  IAffiliateTrackerConditionsResponse
> {
  const { fetchPost } = useRestClient();

  return useContextQuery<IAffiliateTrackerConditionsResponse>({
    queryKey: [AFFILIATE_TRACKER_CONDITIONS_QUERY, id],
    queryFn: ({ signal }) => fetchPost<IAffiliateTrackerConditionsResponse>(
      AFFILIATE_TRACKER_CONDITIONS_API_URL,
      null,
      {
        signal,
        permission: AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS.HISTORY_CHANGES_EDIT,
        urlParams: {
          id: id.value,
        },
      },
    ),
    enabled,
  });
}
